// PROGRAM: Product — Product data, card rendering, quick-add UI
// Reads data from window.PROGRAMS (set by Liquid inline script)

(function() {
    'use strict';

    var Product = {
        get products() { return window.PROGRAMS.products || []; },
        get themes() { return window.PROGRAMS.themes || {}; },

        cyclingSavingsValue: 1,
        cyclingSavingsDirection: 1,

        getSavingsBoxContent: function() {
            var cartTotal = 0;
            if (window.PROGRAMS.Cart && PROGRAMS.Cart.cachedCart && PROGRAMS.Cart.cachedCart.total_price) {
                cartTotal = PROGRAMS.Cart.cachedCart.total_price / 100;
            } else if (window.PROGRAMS.cartTotal) {
                cartTotal = window.PROGRAMS.cartTotal;
            }

            var guestTierPercent = 0;
            var guestTierLabel = '';
            if (cartTotal >= 500) { guestTierPercent = 20; guestTierLabel = '20% VIP'; }
            else if (cartTotal >= 230) { guestTierPercent = 15; guestTierLabel = '15% off'; }
            else if (cartTotal >= 140) { guestTierPercent = 10; guestTierLabel = '10% off'; }
            else if (cartTotal >= 67) { guestTierPercent = 0; guestTierLabel = 'FREE SHIPPING'; }
            else { guestTierPercent = 0; guestTierLabel = ''; }

            var calculatedSavings = cartTotal * (guestTierPercent / 100);

            if (cartTotal >= 140 && guestTierPercent > 0) {
                return { header: 'You could save', savings: '$' + calculatedSavings.toFixed(2), subtext: guestTierLabel + ' with Membership' };
            }
            return { header: '', savings: 'FREE SHIPPING', subtext: 'AVAILABLE AT $67+' };
        },

        startSavingsCycle: function() {
            var content = this.getSavingsBoxContent();
            var displays = document.querySelectorAll('.cart-savings-display');
            displays.forEach(function(el) {
                el.textContent = content.savings;
            });
        },

        /* ── Theme & Shared HTML Helpers ─────────────────────────── */

        _resolveTheme: function(theme) {
            var isRetro = theme === 'retro' || (!theme);
            var isBloodgold = theme === 'bloodgold';
            return {
                bg:         isRetro ? '#FFF' : (isBloodgold ? '#FAF9F6' : '#FFFFFF'),
                border:     isRetro ? '#000' : (isBloodgold ? '#8B0000' : '#000'),
                accent:     isRetro ? '#000080' : (isBloodgold ? '#001F3F' : '#000080'),
                titleColor: isRetro ? '#FFF' : (isBloodgold ? '#DAA520' : '#FFF')
            };
        },

        _renderSavingsBox: function(boxContent) {
            return '<table border="1" cellpadding="0" cellspacing="0" style="border-color:#008000;background:#FFFFCC;width:100%;margin:8px auto 0 auto">' +
                '<tr><td style="background:#008000;padding:2px 4px"><font face="Arial" size="1" color="#FFF"><b>Member Savings</b></font></td></tr>' +
                '<tr><td align="center" style="padding:4px"><span class="cart-savings-header">' + (boxContent.header ? '<font face="Arial" size="1" color="#666">' + boxContent.header + '</font><br>' : '') + '</span>' +
                '<font face="Courier New" size="2" color="#008000"><b class="cart-savings-display">' + boxContent.savings + '</b></font><br>' +
                '<font face="Arial" size="1" color="#888"><i class="cart-savings-subtext">' + boxContent.subtext + '</i></font></td></tr>' +
                '</table>';
        },

        _renderButtons: function(product, addSize, viewSize, addPad, viewPad, addMargin) {
            return '<a href="javascript:void(0)" onclick="PROGRAMS.quickAdd(' + product.variantId + ')" class="green-pulse-btn" style="text-decoration:none;display:block;text-align:center;margin-bottom:' + addMargin + '"><font face="Arial" size="' + addSize + '" color="#FFF"><b>&#128722; ADD TO CART</b></font></a>' +
                '<a href="' + product.url + '" class="purple-btn" style="text-decoration:none;display:block;text-align:center"><font face="Arial" size="' + viewSize + '" color="#FFF"><b>&#128065; VIEW PRODUCT</b></font></a>';
        },

        /* ── Unified Card Renderer ───────────────────────────────── */
        /* layout: 'small' | 'grid' | 'large' | 'featured'          */

        renderCard: function(product, theme, layout) {
            var c = this._resolveTheme(theme);
            var boxContent = this.getSavingsBoxContent();
            var savingsHtml = this._renderSavingsBox(boxContent);

            if (layout === 'grid') {
                /* Grid card — wrapped in <td>, full-width image above text */
                return '<td width="50%" valign="top" style="background:' + c.bg + ';border:1px solid ' + c.border + ';padding:8px">' +
                    '<a href="' + product.url + '" style="text-decoration:none;display:block"><img src="' + product.imageLarge + '" style="width:100%;height:auto;border:1px solid ' + c.accent + '" alt="' + product.title + '"></a>' +
                    '<div style="margin-top:6px"><font face="Arial" size="2" color="' + c.accent + '"><b>' + product.title + '</b></font></div>' +
                    '<font face="Courier New" size="2" color="' + c.accent + '"><b>' + product.priceFormatted + '</b></font>' +
                    '<div style="margin-top:8px">' +
                    this._renderButtons(product, '3', '2', '16px 8px', '14px 8px', '6px') +
                    '</div>' + savingsHtml + '</td>';
            }

            if (layout === 'large') {
                /* Large card — full width with accent title bar */
                return '<div style="background:' + c.bg + ';border:1px solid ' + c.border + ';margin-bottom:8px">' +
                    '<div style="background:' + c.accent + ';padding:6px 8px;border-bottom:1px solid ' + c.border + '"><font face="Arial" size="2" color="' + c.titleColor + '"><b>' + product.title + '</b></font></div>' +
                    '<div style="padding:8px">' +
                    '<a href="' + product.url + '"><img src="' + product.imageLarge + '" style="width:100%;height:auto;border:1px solid ' + c.accent + '" alt="' + product.title + '"></a>' +
                    '<div style="margin-top:8px">' +
                    '<font face="Courier New" size="4" color="' + c.accent + '"><b>' + product.priceFormatted + '</b></font>' +
                    '<div style="margin-top:12px">' +
                    this._renderButtons(product, '4', '3', '20px', '16px', '8px') +
                    '</div></div>' + savingsHtml + '</div></div>';
            }

            /* 'small' and 'featured' share the same side-by-side table layout */
            /* Only differences: image size, padding, font sizes */
            var isFeatured = (layout === 'featured');
            var imgSize = isFeatured ? 90 : 80;
            var imgPadLeft = isFeatured ? '10px' : '8px';
            var priceSize = isFeatured ? '3' : '2';
            var marginTop = isFeatured ? '10px' : '8px';
            var addBtnSize = isFeatured ? '3' : '2';
            var addBtnPad = isFeatured ? '14px' : '12px';
            var viewBtnPad = isFeatured ? '12px' : '10px';
            var addBtnMargin = isFeatured ? '6px' : '4px';

            return '<div style="background:' + c.bg + ';border:1px solid ' + c.border + ';padding:8px;margin-bottom:8px">' +
                '<table width="100%" border="0" cellpadding="0" cellspacing="0"><tr>' +
                '<td width="' + imgSize + '" valign="top"><a href="' + product.url + '"><img src="' + product.imageSmall + '" style="width:' + imgSize + 'px;height:' + imgSize + 'px;object-fit:cover;border:1px solid ' + c.accent + '" alt="' + product.title + '"></a></td>' +
                '<td style="padding-left:' + imgPadLeft + '" valign="top">' +
                '<font face="Arial" size="2" color="' + c.accent + '"><b>' + product.title + '</b></font><br>' +
                '<font face="Courier New" size="' + priceSize + '" color="' + c.accent + '"><b>' + product.priceFormatted + '</b></font>' +
                '<div style="margin-top:' + marginTop + '">' +
                this._renderButtons(product, addBtnSize, '2', addBtnPad, viewBtnPad, addBtnMargin) +
                '</div></td></tr></table>' + savingsHtml + '</div>';
        },

        /* ── Legacy wrappers (backward compat — identical HTML output) ── */

        renderCardSmall: function(product, theme) {
            return this.renderCard(product, theme, 'small');
        },

        renderCardGrid: function(product, theme) {
            return this.renderCard(product, theme, 'grid');
        },

        renderCardLarge: function(product, theme) {
            return this.renderCard(product, theme, 'large');
        },

        renderFeatured: function(theme) {
            if (this.products.length === 0) return '';
            var product = this.products[Math.floor(Math.random() * Math.min(this.products.length, 4))];
            return this.renderCard(product, theme, 'featured');
        },

        /* ── Collection renderers ────────────────────────────────── */

        renderQuickAddGrid: function(theme, count) {
            var products = this.products.slice(0, count || 4);
            if (products.length === 0) return '<font face="Arial" size="2" color="#999"><i>No products available</i></font>';
            var html = '<table width="100%" border="0" cellpadding="4" cellspacing="4"><tr>';
            for (var i = 0; i < products.length; i++) {
                html += this.renderCard(products[i], theme, 'grid');
                if (i % 2 === 1 && i < products.length - 1) html += '</tr><tr>';
            }
            return html + '</tr></table>';
        },

        renderQuickAddList: function(theme, count) {
            var products = this.products.slice(0, count || 4);
            if (products.length === 0) return '<font face="Arial" size="2" color="#999"><i>No products available</i></font>';
            var html = '';
            for (var i = 0; i < products.length; i++) { html += this.renderCard(products[i], theme, 'small'); }
            return html;
        },

        quickAdd: function(variantId) {
            fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: 1 }) })
            .then(function(r) { return r.json(); })
            .then(function() { if (window.PROGRAMS.Cart) PROGRAMS.Cart.fetchCart(); else if (window.CartOS) CartOS.fetchCart(); })
            .catch(function(e) { console.error('PROGRAMS.quickAdd error:', e); });
        },

        init: function() {
            var self = this;
            var containers = document.querySelectorAll('[data-programs]');
            console.log('PROGRAMS Product: Found', containers.length, 'containers,', this.products.length, 'products');
            if (this.products.length === 0) { console.warn('PROGRAMS Product: No products!'); return; }

            this._initContainers(containers);

            console.log('PROGRAMS Product: Initialized', containers.length, 'containers with', this.products.length, 'products');

            // Start savings cycle
            this.startSavingsCycle();

            // Re-run after delay for dynamically loaded sections
            setTimeout(function() {
                self.init_containers();
                if (window.PROGRAMS.Cart && PROGRAMS.Cart.cachedCart) {
                    PROGRAMS.Cart.updateSavingsDisplays(PROGRAMS.Cart.cachedCart);
                }
            }, 500);
            setTimeout(function() {
                self.init_containers();
                if (window.PROGRAMS.Cart && PROGRAMS.Cart.cachedCart) {
                    PROGRAMS.Cart.updateSavingsDisplays(PROGRAMS.Cart.cachedCart);
                }
            }, 1500);
        },

        _initContainers: function(containers) {
            var self = this;
            if (!containers) containers = document.querySelectorAll('[data-programs]');
            if (this.products.length === 0) return;
            containers.forEach(function(el) {
                var type = el.dataset.programs;
                var theme = el.dataset.theme || 'jade';
                var count = parseInt(el.dataset.count) || 4;

                if (type === 'grid') el.innerHTML = self.renderQuickAddGrid(theme, count);
                else if (type === 'list') el.innerHTML = self.renderQuickAddList(theme, count);
                else if (type === 'featured') el.innerHTML = self.renderFeatured(theme);
                else if (type === 'large' && self.products[0]) el.innerHTML = self.renderCard(self.products[0], theme, 'large');
            });
        },

        // Public alias for backward compat (was init_containers)
        init_containers: function() {
            this._initContainers();
        }
    };

    // Register with PROGRAMS
    window.PROGRAMS.register('Product', Product);

    // BACKWARD COMPATIBILITY: alias old PROGRAMS methods
    window.PROGRAMS.quickAdd = function(variantId) { return Product.quickAdd(variantId); };
    window.PROGRAMS.renderCardSmall = function(p, t) { return Product.renderCardSmall(p, t); };
    window.PROGRAMS.renderCardGrid = function(p, t) { return Product.renderCardGrid(p, t); };
    window.PROGRAMS.renderCardLarge = function(p, t) { return Product.renderCardLarge(p, t); };
    window.PROGRAMS.renderFeatured = function(t) { return Product.renderFeatured(t); };
    window.PROGRAMS.renderQuickAddGrid = function(t, c) { return Product.renderQuickAddGrid(t, c); };
    window.PROGRAMS.renderQuickAddList = function(t, c) { return Product.renderQuickAddList(t, c); };
    window.PROGRAMS.getSavingsBoxContent = function() { return Product.getSavingsBoxContent(); };
    window.PROGRAMS.startSavingsCycle = function() { return Product.startSavingsCycle(); };

})();
